import firebase from 'firebase'

const firebaseConfig = {
  apiKey: "AIzaSyDiPlvsMonTxdV9K6LWaH2DKD1LBhZCBKw",
  authDomain: "colaborar-362fa.firebaseapp.com",
  projectId: "colaborar-362fa",
  storageBucket: "colaborar-362fa.appspot.com",
  messagingSenderId: "827572327219",
  appId: "1:827572327219:web:f8ef4f8fe1fee8c42a2446"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();
const auth = firebase.auth();
const storage = firebase.storage();
export {db, auth, storage};